import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuditLogService {

  constructor(private httpClient: HttpClient,) { }

  private apiUrl = environment.apiUrl;

  getAuditLogList(page: number, pageSize: number, filters?: any): Observable<any> {
    const params = { page, pageSize };
    return this.httpClient.post(
      `${this.apiUrl}/AuditLog/GetAuditLogList`, filters || {}, { params }
    );
  }

  getAuditlogDetailById(id: number): Observable<any> {
    return this.httpClient.get(`${this.apiUrl}/AuditLog/GetAuditlogDetailById?id=${id}`).pipe(
      //catchError(this.error)
    );;
  }

}
